/**
 * The text of a small body received as a blob: a request made with `responseType: "blob"`
 * gets its JSON refusals (a 409's `detail`, a 202 deferral) as a Blob too. Falls back to
 * FileReader where `Blob.text` is missing (jsdom).
 */
export const blobText = (blob: Blob): Promise<string> =>
    typeof blob.text === "function"
        ? blob.text()
        : new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = () => resolve(String(reader.result ?? ""));
              reader.onerror = () => reject(reader.error);
              reader.readAsText(blob);
          });

/** A small blob body as JSON, or `{}` when it is not JSON (an empty body, a proxy's HTML
 *  page): how a blob-typed refusal gets its `detail` back without a second failure. */
export const blobJson = (blob: Blob): Promise<unknown> =>
    blobText(blob)
        .then((text): unknown => JSON.parse(text))
        .catch(() => ({}));
